import { updateUsers, Users } from '@/entities/users';
import { UserService } from '@/services/UserService';
import { useEffect, useState } from 'react';

export function useUsers(userid?: number){
  const [users, setUsers] = useState<Users[]>([]);
  const [idToEdit, setIdToEdit] = useState<number>(NaN);
  const [actualUser, setActualUser] = useState<Users>();
  const [open, setOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState<Users | null>(null);
  const [userId, setUserId] = useState<number>();
  const [editUser, setEditUser] = useState(false);
  useEffect(()=>{
    if(userid) {
      getUserById(userid);
      return;
    }
    fetchUsers();
  },[]);
  const fetchUsers = async () =>{
    const response = await UserService.getAllUsers();
    if(response){
      const users = response.map((user:any)=>({
        userId: user.userId,
        name: user.name,
        email: user.email,
        companyId: user.companyId,
        company: user.company,
        role: user.role,
        colaboratorId: user.colaboratorId,
      }));

      setUsers(users);
    }
    
  };

  const getUserById = async (id:number) => {
    const response = await UserService.getUserById(id);
    if(response){
      const user = {
        userId: response.userId,
        name: response.name,
        email: response.email,
        companyId: response.companyId,
        role: response.role.name,
        company: response.company,
        colaboratorId: response.colaboratorId,
      };
      setActualUser(user);
    }
  };

  const deleteUser = async (id: number) => {
    const response = await UserService.deleteUser(Number(id));
    if(response){
      fetchUsers();
      return response;
    }
  }

  const updateUser = async (id: number, user: updateUsers) => {
    const response = await UserService.updateUser(Number(id), user);
    if(response) {
      return response;
    }
  }

  const updateColaboratorIdByEmail = async (colaboratorId: number, email: string) => {
    const response = await UserService.updateColaboratorIdByEmail(Number(colaboratorId), email)
    if(response) {
      return response;
    }
  }

  return{
    editUser, 
    setEditUser,
    selectedUser,
    setSelectedUser,
    users,
    actualUser,
    getUserById,
    userId,
    idToEdit,
    open,
    setOpen,
    setIdToEdit,
    deleteUser, 
    setUserId,
    updateUser,
    updateColaboratorIdByEmail
  };

}
